<template>
  <div>
    <div class="product-window group-con" :class="attr.cartAttr === true ? 'on' : ''"
      :style="'padding-bottom:' + (isShowBtn ? '0' : '')">
      <div class="textpic acea-row row-between-wrapper">
        <div class='title'>
          <div class="titles">
            兑换券
          </div>
        </div>

        <!-- <div class="iconfont sm">

                  使用说明
              </div> -->
        <div class="iconfont icon-guanbi" @click="closeAttr"></div>
      </div>

      <div class="tab">
        <ul>
          <li :class="{ active: type === true }" @click='switchTab(type)'>可用券({{ useCoupon }})</li>
          <li :class="{ active: type === false }" @click='switchTab(type)'>不可用券({{ dontUse }})</li>
        </ul>
      </div>
      <!-- 
      <div class="newCard">
          <span :to="'/user/bindcoupon'" class="binding" >
          <span @click='bindNewCard()' class="binding" >
        <div>+新增绑定</div>
          </span>
      </div> -->

      <div class="cardList">
        <!-- type === true ? (item.types === 2 ? 'ciCard' : ( item.isCannot ? 'noCard' : 'card' )): (item.types === 2 ? 'ciGray' : (item.isCannot ? 'noGray' : 'gray')) -->
        <!-- <div :class="classname(item)" v-for="(item, index) in attr.productAttr" :key="index">

          <div class="cardNum">
            券号<br>
            {{ item.coupon_title }}
          </div>
          <div class="date">
            {{ item.end_time }}到期
          </div>
          <div class="guanbi" v-if='type === true' @click='jiebang(item.id)'>
            <img src="../assets/images/close.png" alt="">

          </div>
          <div class="guoqi" v-if='type === false'>
            <div v-if='item.coupon_price == 0.00'>
              <img src="../assets/images/over.png" alt="">

            </div>
            <div v-else>
              <img src="../assets/images/date.png" alt="">
            </div>

          </div>
          <div :class="type === true ? 'yue' : 'grayyue'">
            余额：{{ item.coupon_price }}点
          </div>

          <div class="bz">
            *此券解绑后其他账号可进行绑定支付
          </div>
        </div> -->

        <!-- 新卡券样式 -->

        <div class="newCardCoupon" v-for="(item, index) in attr.productAttr" :key="index">
          <div v-if='item.coupon_price == 0.00' class="CouponImg">
            <img src="../assets/images/runout.png" alt="">
          </div>
          <div v-else>
            <img v-if='type === false' class="CouponImg" src="../assets/images/beoverdue.png" alt="">
          </div>
          <!-- 上半部分 -->
          <div style="margin-top:0.3rem;">
            <div>
              <div class="Coupon_upper1">
                <div>
                  <div class="Coupon_movie" v-if="item.isCannot == true">仅限电影票购单次使用</div>
                  <div v-else>
                    <div class="Coupon_movie" v-if="item.types == 2">此点券仅限单次使用</div>
                    <div class="Coupon_movie" v-else-if="item.types == 3">仅限购买图书使用</div>
                    <div class="Coupon_movie" v-else-if="item.types == 8">定制券</div>
                    <div class="Coupon_movie" v-else>通用券</div>
                  </div>
                </div>
                <div class="Coupon_upper">
                  <div :class="type ? 'Coupon_money' : 'Coupon_money1'">{{ item.coupon_price }}<span
                      class="Coupon_font">点</span></div>
                  <div class="Coupon_middle">
                    <div>券号：{{ item.coupon_title }}</div>
                    <div>{{ item.end_time }}到期</div>
                  </div>
                  <div :class="type ? 'buttonCoupon' : 'buttonCoupon1'" @click="jiebang(item.id)"
                    v-if="bind_status == 0">
                    解绑</div>
                </div>

              </div>
              <!-- 分割线 -->
              <div class="Splitline"></div>
              <!-- 下办部分 -->
              <div class="Coupon_lower">
                <div class="Coupon_text" v-if="item.types != 8 && item.type_detail == ''">*此券解绑后其它账号可进行绑定支付</div>
                <div style="padding: 0.1rem 0.2rem">{{ item.type_detail }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="noCart" v-if="couponsListLength === 0">
          <div class="pictrue">
            <img src="@assets/images/img_qx_dianquan.png" />
            <div class="noCart_lack">还没有点券哦~</div>
          </div>
        </div>
        <div class="returnBnt bg-color-red" style="margin-bottom: 0.5rem;" @click='bindNewCard()'>绑定新卡券</div>
      </div>
    </div>
    <div class="mask" @touchmove.prevent :hidden="attr.cartAttr === false" @click="closeAttr"></div>

    <Overlay :show="isShow" @click="isShow = false" style="padding-top: 6rem;">
      <div @click.stop>
        <div class="newCouponWaper">
          <div class="dialogcoupon">
            <div class="couponText">绑定新卡券</div>
            <Form v-model="newCard">
              <Field class="Cardroll" v-model="newCard.account" type="number" placeholder="请输入卡号" />
              <Field class="passWord" v-model="newCard.password" type="password" placeholder='请输入密码'></Field>
            </Form>
            <div class="buttonreturn" @click="BindNewCardVolume()">绑定新卡券</div>
            <div class="zhujie">注:7日内卡券绑定/解绑限1次、账户解绑限2张卡券。</div>
          </div>
        </div>
      </div>
    </Overlay>
    <!-- 解绑提示 -->
    <Overlay :show="AccountBan" duration="0">
      <div class="dialog-warp">
        <div class="size1">提示</div>
        <pre class="promptText">
1.解绑后需凭账号密码重新绑定,卡券点数
  将从账户余额中扣除；
      </pre>
        <pre class="promptText">
2.7日内:卡券绑定/解绑限1次、账户解绑
  限2张卡券。
      </pre>
        <div class="button">
          <div class="buttonson" @click="AccountBan = false">取消</div>
          <div class="buttonson1" style="color: red;" @click="AccountOnChange">确定</div>
        </div>
      </div>
    </Overlay>
  </div>
</template>
<script>
import { getUser, getMenuUser, getLogout, getCouponsUser, deleteCoupon,bind} from "@api/user";
import { Field, Overlay, Form } from 'vant';
export default {
  name: "ProductCouponWindow",
  props: {
    attr: {
      type: Object,
      default: () => { }
    },
    iSplus: {
      type: String,
      default: ""
    },
    useCoupon: {
      type: String,
      default: 0
    },
    dontUse: {
      type: String,
      default: 0
    },
    bindStatus: {
      type: Number,
      default: 0
    },
    uStatus: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      type: true,
      cannot_purchase_goods: [ // 不能购买商品、门票，只能用于购买电影的点券
        { min: 80026683, max: 80027063 },
        // 测试↓
        { min: 80027183, max: 80027184 }
      ],
      isShow: false,
      newCard: {
        account: "",
        password: "",
      },
      bind_status: 0,
      AccountBan: false,
      jiebangId:'',
    };
  },
  computed: {
    isShow() {
      return this.$route.path.indexOf("detail") === 1;
    },
    isShowBtn() {
      return this.$route.path.indexOf("group_rule") != -1;
    }
  },
  watch: {
    bindStatus: {
      handler(newValue) {
        this.bind_status = newValue
      }
    }
  },
  mounted: function () {
    if (this.uStatus == 0) {
      this.type = false
    }
  },

  components: {
    Field,
    Overlay,
    Form
  },
  methods: {
    bindNewCard() {
      // getUser().then(res => {
      //   // that.userInfo = res.data;
      //   // console.log(res.data);

      //   if(!res.dpasswordata.phone)
      //   {
      //     this.$dialog.toast({ mes: "请先绑定手机号！" });
      //     this.$router.push({ path: '/user/binding' });
      //   }else{
      //     this.$router.push({ path: '/user/bindcoupon' });
      //   }
      // });

      //关闭下层弹框
      // this.attr.cartAttr = false
      this.isShow = true
      this.newCard = {
        account: "",
        password: "",
      }
    },
    // 绑定新卡券
    BindNewCardVolume() {
      const { account, password } = this.newCard
      bind({ account, password }).then(res => {
        if (res.status == 200) {
          this.$dialog.success(res.msg)
          getCouponsUser(0, 1).then(res => {
            this.couponsList = res.data;
            this.couponsListLength = res.data.length;
            this.attr.productAttr = res.data;
          });
          this.$parent.getCoupons()
          this.$parent.User()
          this.isShow = false

        } else {
          this.$dialog.error(res.msg)
        }
      }).catch(err => {
        this.$dialog.error(err.msg);
      })
    },

    jiebang(id) {
      this.AccountBan = true
      this.jiebangId=id
    },
    AccountOnChange() {
      let id =this.jiebangId
      deleteCoupon(id).then(res => {
        getCouponsUser(0, 1).then(res => {
            this.couponsList = res.data;
            this.useCoupon = res.data.length;
            this.attr.productAttr = res.data;
            this.isCannotP();
            this.$parent.getCoupons()
            this.$parent.User()
          });
          this.$dialog.success("解绑成功");
          this.AccountBan=false
        }).catch((err) => {
          this.$dialog.error(err.msg)
          this.AccountBan=false
        });
 
        
    },
    isCannotP() {
      for (let i = 0; i < this.attr.productAttr.length; i++) {
        let card = this.attr.productAttr[i].coupon_title || '';
        for (let t = 0; t < this.cannot_purchase_goods.length; t++) {
          if (card >= this.cannot_purchase_goods[t].min && card <= this.cannot_purchase_goods[t].max) {
            if (card != 80026760 && card != 80026695 && card != 80027047 && card != 80026958 && card != 80026957) {
              this.attr.productAttr[i].isCannot = true;
            }
          }
        }
      }
    },
    // 切换
    switchTab(type) {
      if (!type) {
        getCouponsUser(0, 1).then(res => {
          this.couponsList = res.data;
          this.couponsListLength = res.data.length;
          this.attr.productAttr = res.data;
          // console.log(res.data);
          // console.log('******************')
          this.isCannotP();
        });
        // console.log('可用');
      } else {
        getCouponsUser(0, 2).then(res => {
          this.couponsList = res.data;
          this.couponsListLength = res.data.length;
          this.attr.productAttr = res.data;
          console.log(res.data.length);
          // console.log('******************')
          this.isCannotP();
        });
        // console.log('不可用')
      }

      this.type = !this.type;
    },
    openAlone() {
      this.$emit("changeFun", { action: "goPay", value: false });
    },
    closeAttr: function () {
      this.$emit("changeFun", { action: "changeattr", value: false });
    },
    CartNumDes: function () {
      this.$emit("changeFun", { action: "ChangeCartNum", value: false });
    },
    CartNumAdd: function () {
      this.$emit("changeFun", { action: "ChangeCartNum", value: 1 });
    },
    tapAttr: function (indexw, indexn) {
      let that = this;
      that.attr.productAttr[indexw].index = indexn;
      let value = that
        .getCheckedValue()
        .sort()
        .join(",");
      that.$emit("changeFun", { action: "ChangeAttr", value: value });
    },
    //获取被选中属性；
    getCheckedValue: function () {
      let productAttr = this.attr.productAttr;
      let value = [];
      for (let i = 0; i < productAttr.length; i++) {
        for (let j = 0; j < productAttr[i].attr_value.length; j++) {
          if (productAttr[i].index === productAttr[i].attr_value[j].attr) {
            value.push(productAttr[i].attr_value[j].attr);
          }
        }
      }
      return value;
    }
  }
};
</script>
<style scoped>
.guanbi img {
  width: 0.4rem;
  height: 0.4rem;
  float: right;
  top: -1.35rem;
  position: relative;
  margin-right: 0.1rem;
}

.guoqi {
  width: 1.5rem;
  height: 1.5rem;
  float: right;
  /* top: 0.2rem; */
  margin-right: 0.2rem;
  position: relative;
}

.guoqi img {
  width: 100%;
  height: 100%;
  background-image: url("");
  z-index: 9999;

}

.title {
  width: 100%;
  height: 0.5rem;
}

.titles {
  text-align: center;
  padding-left: 1rem;
  font-size: 0.4rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #31170A;
}

.iconfont {
  font-size: 0.25rem !important;
  top: -0.09rem !important;
}

.product-window {
  padding-bottom: 0rem !important;
}

.sm {
  /* position:absolute; */
  right: 0.8rem !important;
  top: -0.12rem !important;
  float: right;
  font-size: 0.25rem !important;
  font-family: PingFang;
  font-weight: 500;
  color: #676767;
}

.tab {
  width: 100%;
  height: 0.7rem;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 0.8rem;
  padding-top: 0.5rem;
}

.tab ul {
  margin: 0 auto;
  text-align: center;
  /* list-style-type:none; */
}

.tab ul li {
  margin-left: 0.2rem;
  /* border:solid 1px red; */
  float: left;
  width: 3.5rem;
  display: inline;
  list-style-type: none;
  padding: 0rem 0 0.2rem 0;
}

.active {
  /* border-bottom:solid 1px blue; */
  border-bottom: 0.05rem solid #e93323;
  font-weight: bold;
  /* height:0.2rem; */
  /* border:solid 1px red; */
}

.newCard {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  padding-left: 0.4rem;
  font-size: 0.3rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #31170A;
}

.cardList {
  height: 5.5rem;
  width: 10rem;
  overflow-y: scroll;
  /* padding-top:0.2rem; */
  padding-bottom: 0.6rem;
  background: #f5f5f5;
}

.cardList .card {

  height: 3.5rem;
  width: 7rem;
  margin: 0.2rem;
  padding-top: 0.5rem;
  background-image: url("../assets/images/card.png");
  background-size: 100% 100%;
  position: relative;
}

.cardList .ciCard {
  height: 3.5rem;
  width: 7rem;
  margin: 0.2rem;
  padding-top: 0.5rem;
  background-image: url("../assets/images/ci.jpg") !important;
  background-size: 100% 100%;
  position: relative;
}

.cardList .noCard {
  height: 3.5rem;
  width: 7rem;
  margin: 0.2rem;
  padding-top: 0.5rem;
  background-image: url("../assets/images/card-movie.png");
  background-size: 100% 100%;
  position: relative;
}

.cardList .book {
  height: 3.5rem;
  width: 7rem;
  margin: 0.2rem;
  padding-top: 0.5rem;
  background-image: url("../assets/images/bookCard.png");
  background-size: 100% 100%;
  position: relative;
}

.cardList .ciGray {
  height: 3.5rem;
  width: 7rem;
  margin: 0.2rem;
  padding-top: 0.5rem;
  background-image: url("../assets/images/cigray.jpg");
  background-size: 100% 100%;
  /* position: absolute; */
  position: relative;
}

.cardList .grayBook {
  height: 3.5rem;
  width: 7rem;
  margin: 0.2rem;
  padding-top: 0.5rem;
  background-image: url("../assets/images/gray-book.png");
  background-size: 100% 100%;
  position: relative;
}

.cardList .gray {
  height: 3.5rem;
  width: 7rem;
  margin: 0.2rem;
  padding-top: 0.5rem;
  background-image: url("../assets/images/gray.png");
  background-size: 100% 100%;
  /* position: absolute; */
  position: relative;

}

.cardList .noGray {
  height: 3.5rem;
  width: 7rem;
  margin: 0.2rem;
  padding-top: 0.5rem;
  background-image: url("../assets/images/gray-movie.png");
  background-size: 100% 100%;
  /* position: absolute; */
  position: relative;

}

.cardNum {

  position: relative;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  top: -0.35rem;
  left: 1.3rem;
  color: #fff;
  line-height: 0.47rem;
}



.date {
  position: relative;
  float: right;
  top: 0.65rem;
  right: 0.2rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #fff;
  position: absolute;
}

.yue {
  margin: 0 auto;
  width: 100%;
  text-align: center;
  font-size: 0.48rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #E83627;
  top: 1.6rem;
  position: absolute;
}

.grayyue {
  margin: 0 auto;
  width: 100%;
  text-align: center;
  font-size: 0.48rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #999999;
  top: 1.6rem;
  position: absolute;
}

.bz {
  margin: 0 auto;
  width: 100%;
  text-align: center;
  font-size: 0.2rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #999999;
  top: 2.4rem;
  position: absolute;


  /* padding:0.2rem;
  text-align:center;
  font-size: 0.1rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #999999;
  top: 3rem;
      position: absolute; */
}

.joinCart {
  width: 80%;
  height: 0.76rem;
  line-height: 0.76rem;
  text-align: center;
}

.ipt_num {
  width: 100%;
  display: block;
  line-height: 0.54rem;
  text-align: center;
}

.returnBnt {
  width: 7.5rem;
  height: 0.86rem;
  border-radius: 0.5rem;
  color: #fff;
  font-size: 0.3rem;
  text-align: center;
  line-height: 0.86rem;
  margin-top: 0.3rem;
}

.newCouponWaper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.dialogcoupon {
  width: 5.7rem;
  /* height: 3.5rem; */
  background-color: #fff;
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
}

.couponText {
  width: 100%;
  text-align: center;
  font-size: 0.35rem;
  font-weight: 600;
  padding-top: 0.2rem;
}

.Cardroll {
  width: 80%;
  margin-left: 0.2rem;
  border-bottom: 0.01rem solid #ece9e9;
}

.passWord {
  width: 80%;
  margin-left: 0.2rem;
  border-bottom: 0.01rem solid #ece9e9;
  margin-top: 0.1rem;
}

.buttonreturn {
  width: 4rem;
  height: 0.6rem;
  border-radius: 0.5rem;
  color: #fff;
  font-size: 0.3rem;
  text-align: center;
  line-height: 0.6rem;
  margin: 0 auto 0.2rem auto;
  margin-top: 0.3rem;
  background-color: #e93323 !important;
}

.newCardCoupon {
  width: 70%;
  /* height: 2.5rem; */
  margin-left: 0.22rem;
  margin-top: 0.2rem;
  position: relative;
}

.CouponImg {
  position: absolute;
  top: 1.5rem;
  right: 0.1rem;
  width: 1.5rem;
  height: 1.5rem;
}

.Coupon_upper {
  width: 100%;
  height: 1.2rem;
  background: white;
  border-radius: 0rem 0.2rem 0.27rem 0.27rem;
  display: flex;
  justify-content: space-between;
}

.Coupon_upper1 {
  width: 100%;
  height: 1.8rem;
  background: white;
  border-radius: 1rem 0.2rem 0.27rem 0.27rem;
}

.SingleCoupon {
  width: 100%;
  text-align: center;
  padding-top: 0.1rem;
  font-size: 0.3rem;
  color: #E83627;
}

.Coupon_movie {
  width: 6.5rem;
  height: 0.5rem;
  text-align: left;
  padding-left: 0.2rem;
  line-height: 0.5rem;
  color: white;
  background: url('../assets/images/coup_movie.png') no-repeat;
}

.Splitline {
  width: 94%;
  height: 0.05rem;
  margin-left: 0.2rem;
  border-top: 0.05rem dotted #9F9F9F;
}

.Coupon_lower {
  width: 100%;
  min-height: 0.65rem;
  background: white;
  border-radius: .27rem .27rem 0.2rem 0.2rem;
}

.Coupon_money {
  width: 2.5rem;
  color: #E83627;
  font-size: 0.65rem;
  padding-top: 0.4rem;
  padding-left: 0.2rem;
  font-weight: 600;
}

.Coupon_money1 {
  width: 2.5rem;
  color: #292929;
  font-size: 0.65rem;
  padding-top: 0.4rem;
  padding-left: 0.2rem;
  font-weight: 600;
}

.Coupon_font {
  font-size: 0.3rem;
}

.buttonCoupon {
  width: 1.4rem;
  height: 0.6rem;
  border-radius: 0.5rem;
  color: #fff;
  font-size: 0.3rem;
  text-align: center;
  line-height: 0.6rem;
  margin: 0 auto 0.2rem auto;
  margin-right: 0.2rem;
  background-color: #e93323 !important;
  margin-top: 0.5rem;
}

.buttonCoupon1 {
  width: 1.4rem;
  height: 0.6rem;
  border-radius: 0.5rem;
  color: white;
  font-size: 0.3rem;
  text-align: center;
  line-height: 0.6rem;
  margin: 0 auto 0.2rem auto;
  margin-right: 0.2rem;
  background-color: #FFC0BE !important;
  margin-top: 0.5rem;
  pointer-events: none;
}

.Coupon_middle {
  padding: 0.4rem 0.3rem;
}

.Coupon_text {
  padding-top: 0.1rem;
  padding-left: 0.2rem;
  font-size: 0.3rem;
  color: #9F9F9F;
}

.van-overlay {
  z-index: 23 !important;
}

.mask {
  z-index: 21;
}

.product-window {
  z-index: 22 !important;
}

.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  padding: 0.2rem 2rem;
}


.noCart_lack {
  width: 51%;
  text-align: center;
  padding-top: 0.5rem;
}



.dialog-warp {
  width: 5.5rem;
  /* height: 3rem; */
  position: fixed;
  top: 5rem;
  left: 53%;
  margin-left: -3rem;
  background-color: white;
  /* border-radius: 0.25rem 0.25rem 0.25rem 0.25rem; */
  padding: 0.1rem;
  /* border: 0.02rem solid black; */
  font-family: 'PingFang'
}

.dialog-warp .size1 {
  width: 100%;
  font-size: 0.35rem;
  color: rgb(83, 83, 83);
  text-align: center;
  margin-top: 0.1rem;
  font-weight: 900;
  padding-bottom: 0.2rem;
}

.dialog-warp .button {
  width: 100%;
  display: flex;
  margin-top: 0.15rem;
}

.dialog-warp .button .buttonson {
  width: 2.75rem;
  height: 0.7rem;
  text-align: center;
  line-height: 0.7rem;
  font-size: 0.3rem;
  border-top: 0.01rem solid #ebe5e5;
  border-right: 0.01rem solid #ebe5e5;
}
.dialog-warp .button .buttonson1 {
  width: 2.75rem;
  height: 0.7rem;
  text-align: center;
  line-height: 0.7rem;
  font-size: 0.3rem;
  border-top: 0.01rem solid #ebe5e5;
}
.zhujie{
  width: 100%;
  font-size: 0.22rem;
  color: #7a7979;
  text-align: center;
  padding-bottom: 0.2rem;
}

.promptText{
  font-size: 0.27rem;
  font-family:PingFangMedium;
  width: 100%;
  padding-left: 0.3rem;
}
</style>
